import { Injectable, InjectionToken, inject } from '@angular/core';
import { Environment } from '../environments/environment.model';

export const ENVIRONMENT_JSON = new InjectionToken<Environment>('environment-json');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private env = inject<Environment>(ENVIRONMENT_JSON);

  _environment: Environment;

  constructor() {
    // console.log('@Inject Environment:', this.env);
    this._environment = this.env;
  }

  get environment(): Environment {
    // return useEnvironment();
    return this._environment;
  }
}
